import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { api, API } from "@/lib/api";
import { dispatchWOChanged } from "@/lib/woEvents";

const POLL_MS = 120000;   // cadangan; utama via SSE realtime
const SHOW_MS = 7000;
const GREEN = "#15803D";

export const WODoneNotifier = () => {
  const [queue, setQueue] = useState([]);
  const sinceRef = useRef(null);
  const seenRef = useRef(new Set());

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const r = await api.woDoneNotifications(sinceRef.current);
        if (!alive) return;
        const fresh = (r.items || []).filter(i => !seenRef.current.has(i.id));
        fresh.forEach(i => seenRef.current.add(i.id));
        if (fresh.length) setQueue(q => [...q, ...fresh]);
        sinceRef.current = r.server_time;
      } catch {}
    };
    poll();
    const t = setInterval(poll, POLL_MS);

    // Realtime: server push (change stream WO) → popup + refresh kalender
    let refreshT = null;
    const es = new EventSource(`${API}/wo/events`, { withCredentials: true });
    es.addEventListener("ready", () => { if (sinceRef.current) poll(); });   // tangkap yg terlewat saat reconnect
    es.addEventListener("wo_done", (e) => {
      const i = JSON.parse(e.data);
      if (!i.id || seenRef.current.has(i.id)) return;
      seenRef.current.add(i.id);
      setQueue(q => [...q, i]);
    });
    es.addEventListener("msg_new", (e) => {
      window.dispatchEvent(new CustomEvent("gac:msg-new", { detail: JSON.parse(e.data) }));
    });
    es.addEventListener("wo_changed", () => {
      clearTimeout(refreshT);
      refreshT = setTimeout(() => dispatchWOChanged({ source: "sse" }), 1500);
    });
    return () => { alive = false; clearInterval(t); clearTimeout(refreshT); es.close(); };
  }, []);

  const current = queue[0];
  useEffect(() => {
    if (!current) return;
    const t = setTimeout(() => setQueue(q => q.slice(1)), SHOW_MS);
    return () => clearTimeout(t);
  }, [current]);

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none">
      <AnimatePresence mode="wait">
        {current && (
          <motion.div
            key={current.id}
            initial={{ y: -120, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -120, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 28 }}
            className="pointer-events-auto rounded-md shadow-lg px-4 py-2.5 flex items-start gap-2.5 min-w-[260px] max-w-[420px]"
            style={{ backgroundColor: "#FFFFFF", color: GREEN, border: `1px solid #BBF7D0` }}
            data-testid="wo-done-popup"
          >
            <CheckCircle2 className="w-5 h-5 mt-0.5 shrink-0" style={{ color: GREEN }} />
            <div className="text-[13px] leading-snug" style={{ color: GREEN }}>
              <div className="font-bold" data-testid="wo-done-popup-status">WO: Done</div>
              <div data-testid="wo-done-popup-armada">Armada: <b>{current.armada}</b></div>
              <div className="truncate max-w-[360px]" title={current.address} data-testid="wo-done-popup-address">Alamat: {current.address}</div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
